(ns hai.onboarding
  "The Humble Setup steps, shared by the surfaces that show them.

   Home renders them as a checklist that stamps and retires itself (see
   [[hai.home.onboarding]]); the profile page renders the same three as a
   permanent reference. Only the step list is shared — each surface draws its
   own rows, since what sits beside a label differs between them."
  (:require
   [url.install :as install]))

;; The step without an `:href` is the one that carries the new-tab switch.
(def steps
  [{:key   :onboarding.step/browser
    :label "Install Browser Extension"
    :href  install/chrome-store-url-from-home}
   {:key   :onboarding.step/homepage
    :label "Enable Browser New Tab"}
   {:key   :onboarding.step/mobile
    :label "Add Humble to Mobile"
    :href  install/mobile-setup-url}])
